import { isBrowser } from './is-browser';
export function isDarkMode() {
  return isBrowser() ? document.cookie.split('; ').find(row => row.startsWith('_frt_')) : false;
}